
import {  MY_ACCOUNT, ErrorPages, MyAccountService, toastr, REDIRECT, logoutUser,
          dataURItoBlob, CustomCropperAction, CustomToastrAction, COMMON, CommonAction }  from "@/imports-files/pages/clients/my-account";

export class MyAccountAction
{

    constructor(setApiError, setShowLoader, t)
    {
      this.t                    =   t;
      this.setApiError          =   setApiError;
      this.errorPage            =   new ErrorPages();
      this.cropperAction        =   new CustomCropperAction();
      this.setShowLoader        =   setShowLoader;
      this.customToastrAction   =   new CustomToastrAction();
      this.commonAction         =   new CommonAction();
    }

    async getUserDetails(router)
    {  
        var body      =  {step: router.query.step}
        const result  =  await new MyAccountService().getDetails(body);
        this.setApiError(result.request);
        return result.data 
    }


    async updateUserDetails(params, router, quick_setup, updateUser, client_slug, setInitialValues, deleteImageUrls)
    {
        this.setShowLoader(true);
        // const videoToken = document.querySelector(`#myinterview-videoId`).value;
        const formData = new FormData();
        formData.append("user[video_]",  params.name)
        formData.append("user[name]",  params.name)
        formData.append("user[email]", params.email)
        formData.append("user[biography]", params.biography || '')
        formData.append("user[email_signature]",  params.email_signature || '')
        formData.append("user[newsletter]",  params.newsletter )
        // videoToken ? formData.append("user[introduction_video_key]", videoToken) : '';
        formData.append("user[introduction_video_from]", 'client user');
        deleteImageUrls?.map((image_url, index) => {
          formData.append(`delete_image_urls[${index}]`, image_url)
          return image_url;
        })
        if(params.password) formData.append("user[password]", params.password)

        if(params?.photo?.file && params?.photo?.file_name)
        {
          var blob_data   = document.querySelector('#User_Profile').getAttribute('src');
          blob_data       = await dataURItoBlob(blob_data);
          formData.append("user[photo]", blob_data, params.photo.file_name);
        }

        if(quick_setup)(formData.append("quick_setup", quick_setup))
        const result = await new MyAccountService().updateUserDetails(formData, client_slug);
        this.setApiError(result.request);

        if(result.request.status == 200)
        {
          this.setShowLoader(false);
          this.customToastrAction.setNormalToastr(result.data.success, 'success');
          // toastr.success(result.data.success)
          var base64Data = await this.commonAction.convertUrlToBase64(result.data.user.photo_url);
          await updateUser({user_image: base64Data || result.data.user.photo_url,  user_name: result.data.user.name, name_initials: result.data.user.name_initials});
          if(result.data.user.photo_url){
            document.querySelector('.AvatarImage').src = result.data.user.photo_url || COMMON.DUMMY_IMAGE;
            this.showImageOrInitials(true)
          }
          else{
            document.querySelector('.AvatarInitials').innerText = result.data.user.name_initials
            this.showImageOrInitials(false);
          }
          document.querySelector('.AvatarName').textContent = result.data.user.name;
          if(result.data.next_step)
          {
            let next_step = result.data.next_step
            let url = `${REDIRECT.client.quick_setup}${next_step}`;
            (next_step == 'complete') ? router.push(REDIRECT.client.activities) : router.push(url)
          }
          setInitialValues(result.data.user);
        }
        else
        {
          this.setShowLoader(false);
          return result.response.data.error.user
        }
        
    }

    handleSelectJobValueOnChange(data, formik)
    {
        formik.setFieldValue("role_id", data.value);
    }

    closeCropperModal()
    {
      this.cropperAction.destroy_cropper();
      document.querySelector('.CropperModal').style.visibility = 'hidden';                                                                             
    }

    zoom_in()
    {
      this.cropperAction.zoom_in();
    }
  
  
    zoom_out()
    {
      this.cropperAction.zoom_out();
    }


    onFileChange(event, formik, setImageError) 
    {
      let file  = event.target.files[0]
      if(file.size > MY_ACCOUNT.PHOTO_SIZE)
      {
        setImageError(this.t('errors:image_size'))
      }
      else
      {
        this.hash = {
                        file_name: file.name,
                        file: file,
                        file_size: file.size
                    }

        formik.setFieldValue('photo', this.hash);
        this.image_url = window.URL.createObjectURL(file);
        setImageError('')
        document.querySelector('.CropperModal').style.visibility = 'visible';
        var img_tag = document.querySelector('.Cropper__Image');
        img_tag.src = this.image_url;
        this.cropperAction.initialize_cropping_area();
        event.target.value = '';
      }
    }

    getCroppedImage()
    {
      this.blob_data = this.cropperAction.crop_image();
    }

    handleLogout(router) 
    {
      logoutUser(router, 'ClientUser');
    }

    showImageOrInitials(isImage){
      if(isImage){
        let imageElement = document.querySelector('.AvatarImage')
        if(imageElement) imageElement.classList.remove('dnone');

        let initialElement = document.querySelector('.AvatarInitials')
        if(initialElement) initialElement.style.display = 'none'
      }
      else{
        let imageElement = document.querySelector('.AvatarImage')
        if(imageElement) imageElement.classList.add('dnone');

        let initialElement = document.querySelector('.AvatarInitials')
        if(initialElement) initialElement.style.display = 'flex'
      }
    }

    async imageToBase64(element){
      let url = element.src;
      let promise = new Promise(function (resolve, reject) {
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64String = reader.result;
              resolve(base64String);
            };
        })
      });
      return promise;
  }
}